import React, { useEffect, useState, useRef } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";
import { MAPS_CONFIG } from "./config";
import { API_URL } from "./config";
import carIcon from "./—Pngtree—yellow car top view_14599687.png";

const mapContainerStyle = {
  width: "100%",
  height: "100vh",
};

const LIBRARIES = []; // keep static

const Driversdisplay = () => {
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const mapRef = useRef(null);
  const previousDriverStates = useRef({});

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: MAPS_CONFIG.GOOGLE_MAPS_API_KEY,
    libraries: LIBRARIES,
  });

  const calculateBearing = (lat1, lon1, lat2, lon2) => {
    const toRadians = (deg) => (deg * Math.PI) / 180;
    const toDegrees = (rad) => (rad * 180) / Math.PI;

    const dLon = toRadians(lon2 - lon1);
    const y = Math.sin(dLon) * Math.cos(toRadians(lat2));
    const x =
      Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) -
      Math.sin(toRadians(lat1)) *
        Math.cos(toRadians(lat2)) *
        Math.cos(dLon);

    return (toDegrees(Math.atan2(y, x)) + 360) % 360;
  };

  useEffect(() => {
    if (!isLoaded) return;

    const fetchDriverData = async () => {
      try {
        const response = await fetch(`${API_URL}/driver`);
        const data = await response.json();

        const updatedDrivers = data.map((driver) => {
          const previous = previousDriverStates.current[driver.driver_id];
          let bearing = null;

          if (previous) {
            bearing = calculateBearing(
              previous.lat,
              previous.lng,
              driver.lat_cordinates,
              driver.long_cordinates
            );
          }

          return { ...driver, bearing };
        });

        setDrivers(updatedDrivers);

        data.forEach((driver) => {
          previousDriverStates.current[driver.driver_id] = {
            lat: driver.lat_cordinates,
            lng: driver.long_cordinates,
          };
        });
      } catch (err) {
        console.error("Error fetching driver data:", err);
      }
    };

    fetchDriverData();
    const interval = setInterval(
      fetchDriverData,
      MAPS_CONFIG.INTERVALS.DRIVER_DISPLAY_UPDATE
    );

    return () => clearInterval(interval);
  }, [isLoaded]);

  if (!isLoaded) return <div>Loading map…</div>;

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      center={
        drivers.length
          ? { lat: drivers[0].lat_cordinates, lng: drivers[0].long_cordinates }
          : { lat: -17.8292, lng: 31.0522 }
      }
      zoom={15}
      onLoad={(map) => (mapRef.current = map)}
    >
      {drivers.map((driver) => (
        <Marker
          key={driver.driver_id}
          position={{
            lat: driver.lat_cordinates,
            lng: driver.long_cordinates,
          }}
          icon={{
            url: carIcon,
            scaledSize: new window.google.maps.Size(30, 30),
          }}
          onClick={() => setSelectedDriver(driver)}
        />
      ))}

      {selectedDriver && (
        <InfoWindow
          position={{
            lat: selectedDriver.lat_cordinates,
            lng: selectedDriver.long_cordinates,
          }}
          onCloseClick={() => setSelectedDriver(null)}
        >
          <div>
            <h3>{selectedDriver.name}</h3>
            <p>
              Direction:{" "}
              {selectedDriver.bearing
                ? `${selectedDriver.bearing.toFixed(1)}°`
                : "N/A"}
            </p>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};

export default Driversdisplay;
